<template>
  <div class="notice-list-view">
    <div class="page-header">
      <h2>공지사항</h2>
    </div>

    <div class="notice-cards" v-loading="loading">
      <el-card
        v-for="notice in notices"
        :key="notice.id"
        class="notice-card"
        @click="openDetail(notice)"
      >
        <h3>{{ notice.title }}</h3>
        <p>{{ formatDate(notice.start_date) }} ~ {{ formatDate(notice.end_date) }}</p>
      </el-card>

      <el-empty v-if="!loading && notices.length === 0" description="공지사항이 없습니다" />
    </div>

    <!-- 페이지네이션 -->
    <div class="pagination-container" v-if="pagination.total > 0">
      <el-pagination
        v-model:current-page="pagination.page"
        v-model:page-size="pagination.pageSize"
        :page-sizes="[10, 20, 50]"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next"
        @size-change="fetchNotices"
        @current-change="fetchNotices"
      />
    </div>

    <!-- 공지 팝업 (읽기 전용) -->
    <NoticeDetailDialog
      v-if="selectedNotice"
      :notice="selectedNotice"
      :readonly="true"
      @close="selectedNotice = null"
    />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import axiosInstance from "@/api/axios"
import NoticeDetailDialog from '@/components/NoticeDetailDialog.vue'

const notices = ref([])
const selectedNotice = ref(null)
const loading = ref(false)

const pagination = reactive({
  page: 1,
  pageSize: 10,
  total: 0
})

const fetchNotices = async () => {
  loading.value = true
  try {
    const params = {
      page: pagination.page,
      page_size: pagination.pageSize,
    }
    const res = await axiosInstance.get('/notices/', { params })
    notices.value = res.data.results || res.data
    pagination.total = res.data.count || notices.value.length
  } catch (error) {
    console.error('Failed to fetch notices:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchNotices()
})

const openDetail = (notice) => {
  selectedNotice.value = notice
}

const formatDate = (d) => {
  if (!d) return ''
  return new Date(d).toLocaleDateString()
}
</script>

<style scoped>
.notice-list-view {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
}

.notice-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notice-card {
  cursor: pointer;
  transition: box-shadow 0.2s;
}

.notice-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
}

.notice-card h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.notice-card p {
  margin: 0;
  color: #909399;
  font-size: 13px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
